import { apiFetch } from '../client';

export function fetchUserAdData() {
    return apiFetch('/user-api/get-ad-data/', {method: 'GET'})
}

export function getUserData() {
    return apiFetch('/user-api/data/', {method: 'GET'})
}

export function getUserHubspotSubscriptions() {
    return apiFetch('/user-api/get-user-hubspot-subscriptions/', {method: 'GET'})
}

export function kycPreferences(formData){
    return apiFetch('/user-api/kyc-preferences/', {
        method: 'POST',
        body: JSON.stringify(formData)
    })
}

export function getKycPreferences(){
    return apiFetch('/user-api/kyc-preferences/', {
        method: 'GET'  
    })
}

export function SetSystemAlertSeen(id){
    return apiFetch(`/user-api/system-alert/${id}/`, {
        method: 'PATCH',
        body: JSON.stringify({seen_at: new Date().toISOString()})
    })
}

export function SetSystemAlertDismissed(id){
    return apiFetch(`/user-api/system-alert/${id}/`, {
        method: 'PATCH',
        body: JSON.stringify({dismissed_at: new Date().toISOString()})
    })
}

export function updateUser(data) {
    return apiFetch('/user-api/update/', {
        method: 'POST',
        body: JSON.stringify({ data })
    })
}

export function updateUserHubspotSubscriptions(data) {
    return apiFetch('/user-api/update-user-hubspot-subscriptions/', {
        method: 'POST',
        body: JSON.stringify({ data })
    })
}

export function updateDfrWeeklyEmails(data) {
    return apiFetch('/user-api/update-dfr-weekly-emails/', {
        method: 'POST',
        body: JSON.stringify({ data })
    })
}